export const SourceFrom = {
  Unknown: 0,
  Gui: 1,
  AwsMarketplace: 3,
  AzureMarketplace: 4,
} as const;

export type SourceFromValue = (typeof SourceFrom)[keyof typeof SourceFrom];

export const SourceFromMap = {
  0: 'Unknown',
  1: 'Gui',
  3: 'AWS',
  4: 'Azure',
} as const satisfies Record<SourceFromValue, string>;
